import { render } from "./ListHeading.vue?vue&type=template&id=c6490986"
import script from "./ListHeading.vue?vue&type=script&lang=js"
export * from "./ListHeading.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ListHeading.vue?vue&type=style&index=0&id=c6490986&lang=module.css&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__